// Note-only item for `nocomment` (comment-less 👎) and `positive` (👍) —
// no chat bubble, no avatar (docs/06-ux-rules.md "Thread": "Comment-less 👎
// thread", "👍 row selected"; P5 D2/D7).
import palette from 'constants/palette'
import React from 'react'
import { useStyletron } from 'styletron-react'
import { formatShortDateTime } from 'utilities/dateFormatters'
import { THREAD_NOTE_MAX_WIDTH_PX } from '../constants'

export interface ThreadNoteProps {
  text: string
  at: string
}

// The gap before the date is a real space, not a margin — a margin isn't a
// line-break point, so the note's last word would wrap down with the date
// (AI-1436).
const ThreadNote = ({ text, at }: ThreadNoteProps) => {
  const [css] = useStyletron()

  return (
    <div className={css({ maxWidth: `${THREAD_NOTE_MAX_WIDTH_PX}px` })}>
      <div className={css({ fontSize: '14px', color: palette.grey70 })}>
        {text}{' '}
        <span className={css({ color: palette.grey50, whiteSpace: 'nowrap' })}>
          · {formatShortDateTime(at)}
        </span>
      </div>
    </div>
  )
}

export default ThreadNote
